/* Franzese Wine — Ask Michael's Advice on Wine form behavior
   Loaded with `defer`, runs once after DOMContentLoaded.

   Single string to change if the API ever moves: API_URL.
*/
(function () {
  "use strict";

  var API_URL = "https://franzese-wine.vercel.app/api/send-call";

  function init() {
    var root = document.querySelector(".amf-root");
    if (!root) return;

    var form        = root.querySelector(".amf-form");
    if (!form) return;

    var nameInput   = form.querySelector('[name="name"]');
    var phoneInput  = form.querySelector('[name="phone"]');
    var emailInput  = form.querySelector('[name="email"]');
    var consentBox  = form.querySelector('[name="consent"]');
    var submitBtn   = form.querySelector('button[type="submit"]');
    var errorEl     = root.querySelector(".amf-error");
    var phoneDigits = "";

    function stripPhoneToDigits(raw) {
      var cleaned = String(raw || "").replace(/[^\d]/g, "");
      if (cleaned.length === 11 && cleaned.charAt(0) === "1") return cleaned.slice(1);
      return cleaned;
    }
    function formatPhoneDisplay(digits) {
      if (!digits) return "";
      if (digits.length <= 3) return "(" + digits;
      if (digits.length <= 6) return "(" + digits.slice(0, 3) + ") " + digits.slice(3);
      return "(" + digits.slice(0, 3) + ") " + digits.slice(3, 6) + "-" + digits.slice(6, 10);
    }
    function isValidUSPhone(digits) { return /^\d{10}$/.test(digits); }

    function isFormValid() {
      return (
        nameInput.value.trim().length > 0 &&
        isValidUSPhone(phoneDigits) &&
        consentBox.checked
      );
    }
    function updateButton() { submitBtn.disabled = !isFormValid(); }
    function clearError() { errorEl.hidden = true; errorEl.textContent = ""; }
    function showError(msg) { errorEl.hidden = false; errorEl.textContent = msg; }

    phoneInput.addEventListener("input", function (e) {
      var digits = stripPhoneToDigits(e.target.value);
      if (digits.length > 10) digits = digits.slice(0, 10);
      phoneDigits = digits;
      e.target.value = formatPhoneDisplay(digits);
      clearError();
      updateButton();
    });
    nameInput.addEventListener("input", function () { clearError(); updateButton(); });
    emailInput.addEventListener("input", function () { clearError(); updateButton(); });
    consentBox.addEventListener("change", function () { clearError(); updateButton(); });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      clearError();

      if (!nameInput.value.trim()) return showError("Please enter your name.");
      if (!isValidUSPhone(phoneDigits))
        return showError("Please enter a valid 10-digit US phone number.");
      if (!consentBox.checked) return showError("Please check the consent box to continue.");

      submitBtn.disabled = true;
      submitBtn.textContent = "Requesting Your Call...";

      fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: nameInput.value.trim(),
          phone: "+1" + phoneDigits,
          email: emailInput.value.trim() || null,
          consent: true,
          source: "shopify-franzesewine",
        }),
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok) {
            showError(
              (result.data && (result.data.error || result.data.message)) ||
                "Something went wrong. Please try again."
            );
            submitBtn.disabled = false;
            submitBtn.textContent = "Call Me Back";
            return;
          }
          var phoneEl = root.querySelector(".amf-success-phone");
          if (phoneEl) phoneEl.textContent = formatPhoneDisplay(phoneDigits);
          root.setAttribute("data-amf-state", "success");
        })
        .catch(function () {
          showError("Network error. Please check your connection and try again.");
          submitBtn.disabled = false;
          submitBtn.textContent = "Call Me Back";
        });
    });

    updateButton();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
